import axios from '../axiosConfig'
import {Params} from './variables'

let cachedApiToken: string | null = null

export const getApiToken = async (
    backendUrlApiV2: string,
    forceRefresh = false
): Promise<string | null> => {
    if (!forceRefresh && cachedApiToken) {
        return cachedApiToken
    }

    const response = await axios.get(`${backendUrlApiV2}/${Params.API_TOKEN}`)

    cachedApiToken = response.data.token

    return cachedApiToken
}
